import React, { useMemo } from 'react';
import { useRouter } from '@atlassian/jira-router';
import {
	LastOpenedConfigTab,
	boardSettingsQueryConfigParamValues,
	useIsUserLocatedBoard,
} from '@atlassian/jira-software-board-settings-rapidboard-config-common';
import RapidBoardCardColoursSettings from '@atlassian/jira-spa-apps-classic-board-settings-card-colours';
import RapidBoardCardLayoutSettings from '@atlassian/jira-spa-apps-classic-board-settings-card-layout';
import RapidBoardColumnsSettings from '@atlassian/jira-spa-apps-classic-board-settings-columns';
import RapidBoardEstimationSettings from '@atlassian/jira-spa-apps-classic-board-settings-estimation';
import RapidBoardGeneralSettings from '@atlassian/jira-spa-apps-classic-board-settings-general';
import RapidBoardQuickFiltersSettings from '@atlassian/jira-spa-apps-classic-board-settings-quick-filters';
import RapidBoardSwimlanesSettings from '@atlassian/jira-spa-apps-classic-board-settings-swimlanes';
import RapidBoardTimelinesSettings from '@atlassian/jira-spa-apps-classic-board-settings-timeline';
import RapidBoardWorkingDaysSettings from '@atlassian/jira-spa-apps-classic-board-settings-working-days';

export const BoardConfigSwitcher = () => {
	const [{ query }] = useRouter();
	const isUserLocatedBoard = useIsUserLocatedBoard();

	const configToPageMap: Record<string, JSX.Element | null> = useMemo(
		() => ({
			[boardSettingsQueryConfigParamValues.general]: <RapidBoardGeneralSettings />,
			[boardSettingsQueryConfigParamValues.columns]: <RapidBoardColumnsSettings />,
			[boardSettingsQueryConfigParamValues.swimlanes]: <RapidBoardSwimlanesSettings />,
			[boardSettingsQueryConfigParamValues.quickFilters]: <RapidBoardQuickFiltersSettings />,
			[boardSettingsQueryConfigParamValues.cardColors]: <RapidBoardCardColoursSettings />,
			[boardSettingsQueryConfigParamValues.cardLayout]: <RapidBoardCardLayoutSettings />,
			[boardSettingsQueryConfigParamValues.estimation]: <RapidBoardEstimationSettings />,
			[boardSettingsQueryConfigParamValues.workingDays]: <RapidBoardWorkingDaysSettings />,
			...(!isUserLocatedBoard && {
				[boardSettingsQueryConfigParamValues.timeline]: <RapidBoardTimelinesSettings />,
			}),
		}),
		[isUserLocatedBoard],
	);

	return configToPageMap[query.config] || <LastOpenedConfigTab configParam={query.config} />;
};
